import { render, staticRenderFns } from "./trainingModulePageDashboardSingle7.vue?vue&type=template&id=1b722718&scoped=true&"
import script from "./trainingModulePageDashboardSingle7.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageDashboardSingle7.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageDashboardSingle7.vue?vue&type=style&index=0&id=1b722718&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b722718",
  null
  
)

export default component.exports